module.exports = __webpack_public_path__ + "assets/images/edit-icon.44515a8c7c76e3a911df3aa4dfdd6dcf.svg";